import {
  AutoGenerateWorkQueuesCommand,
  SaveWorkQueueCommand,
  WorkQueueApi,
} from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class WorkQueueService {
  async load(vesselVisitId: number) {
    const { data } = await createApiClient(WorkQueueApi).get(vesselVisitId)

    return data
  }

  async autoGenerateWorkQueues(autoGenerateWorkQueues: AutoGenerateWorkQueuesCommand) {
    await createApiClient(WorkQueueApi).autoGenerateWorkQueues(autoGenerateWorkQueues)
  }

  async saveCraneSplit(saveWorkQueueCommand: SaveWorkQueueCommand) {
    const { data } = await createApiClient(WorkQueueApi).save(saveWorkQueueCommand)

    return data
  }

  async startWorkQueue(workQueueId: number) {
    const { data } = await createApiClient(WorkQueueApi).start({ workQueueId })

    return data
  }

  async stopWorkQueue(workQueueId: number) {
    const { data } = await createApiClient(WorkQueueApi).stop({ workQueueId })

    return data
  }

  async rename(workQueueId: number, name: string | null | undefined) {
    await createApiClient(WorkQueueApi).rename({ workQueueId, name })
  }
}

export const workQueueService = new WorkQueueService()
